import { cacheTypes, getMethodByDispatcher, serverUrl, getheader } from "../../../store/api/CommonFunctions";

export function getExtAttrSettings() {
    return dispatch => {
        fetch(serverUrl + "api/SystemSetting/GetExtAttrSettings", {
            headers: getheader(),
            method: "GET",
            cache: "no-cache"
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    res = [];
                }
                return dispatch({
                    type: "GET_EXT_SETTINGS",
                    data: res
                })
            }).catch(e => {
                console.log("[GET_EXT_SETTINGS] ", e);
                return dispatch({
                    type: "GET_EXT_SETTINGS",
                    data: []
                })
            });
    }
}
export function getExtAttrSettingsForSearch() {
    return dispatch => {
        dispatch(getMethodByDispatcher("api/SystemSetting/GetServiceExtraAttrSettingsForSearch", "GET_EXT_SETTINGS_4SEARCH", cacheTypes.NoCache, "دریافت سایر مشخصه های سرویس"));
    }
}
export function getSystemSettings(data, onGet) {
    let token = localStorage.getItem("token");
    let sUrl = localStorage.getItem("ServerUrl");
    if (token === null || sUrl === null) {
        return dispatch => {
            dispatch({
                type: "GET_SYSTEM_SETTINGS",
                data: []
            });
        }
    }
    return dispatch => {
        fetch(sUrl + "api/SystemSetting/GetSystemSettings", {
            headers: getheader(),
            body: JSON.stringify(data),
            method: "POST",
            cache: "default"
        }).then(res => res.json())
            .then(res => {
                if (res.Message === "Error") {
                    res = [];
                }
                if (onGet) {
                    onGet(res);
                }
                dispatch({
                    type: "GET_SYSTEM_SETTINGS",
                    data: res
                });
            }).catch(e => {
                console.log("[GET_SYSTEM_SETTINGS] ", e);
                dispatch({
                    type: "GET_SYSTEM_SETTINGS",
                    data: []
                })
            });
    }
}
export function getPrintTemplate(templateName) {
    return dispatch => {
        dispatch({
            type: "GET_PRINT_TEMPLATE",
            data: "PENDING"
        });
        fetch(serverUrl + "api/PrintTemplateAPI/GetTemplate?templateName=" + templateName, {
            headers: getheader(),
            method: "GET",
            cache: "no-cache"
        }).then(res => res.json())
            .then(res => {
                if (res === "Error" || res.Message) {
                    res = null;
                }
                dispatch({
                    type: "GET_PRINT_TEMPLATE",
                    data: res
                });
            })
    }
}
export function setPrintViewerPopStatus(status) {
    return dispatch => {
        dispatch({
            type: "PRINT_VIEW_POPSTATUS",
            data: status
        });
    }
}
export function checkSystemVersion() {
    return dispatch => {
        fetch(serverUrl + "api/SystemSetting/CheckSystemVersion", {
            method: "GET",
            headers: getheader(),
            cache: "default"
        }).then(res => res.json()).then(res => dispatch({ type: "CHECK_VERSION", data: res }));
    }
}
export function getStaffExtSettings() {
    return dispatch => dispatch(getMethodByDispatcher(`api/SystemSetting/GetStaffExtSettings`, "STAFF_EXT_SETTINGS", cacheTypes.NoCache, "دریافت مشخصه های تکنسین"));
}